import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {BuyerViewBanner} from '../../app/modules/auth/components/BuyerViewControls'

const MasterLayout = () => {
    const location = useLocation()

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 500)
    }, [location.key])

    // Auto-close (minimize) the sidebar when the viewport is 1200px or narrower
    useEffect(() => {
        const mql = window.matchMedia('(max-width: 1200px)')
        const apply = (matches: boolean) => {
            if (matches) {
                document.body.setAttribute('data-kt-aside-minimize', 'on')
            } else {
                document.body.removeAttribute('data-kt-aside-minimize')
            }
        }
        apply(mql.matches)
        const onChange = (e: MediaQueryListEvent) => apply(e.matches)
        mql.addEventListener('change', onChange)
        return () => mql.removeEventListener('change', onChange)
    }, [])

    return (
        <PageDataProvider>
            <BuyerViewBanner/>
            <div className='page d-flex flex-row flex-column-fluid'>
                <AsideDefault/>
                <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
                    <HeaderWrapper/>

                    <div id='kt_content' className='content d-flex flex-column flex-column-fluid grey_background'>
                        <div className='post d-flex flex-column-fluid' id='kt_post'>
                            <Content>
                                <Outlet/>
                            </Content>
                        </div>
                    </div>
                    <Footer/>
                </div>
            </div>

            {/* begin:: Drawers */}
            <ActivityDrawer/>
            {/*<RightToolbar />*/}
            {/*  Below Component is used in AppChat*/}
            <DrawerMessenger/>
            {/* end:: Drawers */}

            {/* begin:: Modals */}
            <InviteUsers/>
            <UpgradePlan/>
            {/* end:: Modals */}
            <ScrollTop/>

            {/* begin:: Toast Container */}
            <ToastContainer/>
            {/* begin:: Toast Container */}
        </PageDataProvider>
    )
}

export {MasterLayout}
